import React from "react";

const MyJob = () => {
  const jobData = [
    {
      id: 1,
      jobTitle: "Frontend Developer",
      companyName: "Google",
      location: "Remote",
      jobType: "Full Time",
      experience: "2+ years",
      salary: "$70,000 - $90,000",
      description: "React & Tailwind based UI...",
      category: "Development",
    },
    {
      id: 2,
      jobTitle: "Backend Developer",
      companyName: "Netflix",
      location: "Remote",
      jobType: "Part Time",
      experience: "4+ years",
      salary: "$85,000 - $105,000",
      description: "Node.js & MongoDB...",
      category: "Development",
    },
  ];

  return (
    <>
      <h1 className="text-2xl font-bold mb-4 text-[#2B3DA8]">My Jobs</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {jobData.map((job) => (
          <div key={job.id} className="bg-white p-5 rounded-lg shadow hover:shadow-md transition">
            <h2 className="text-xl font-semibold mb-1 text-[#2B3DA8]">{job.jobTitle}</h2>
            <p className="text-gray-600">{job.companyName}</p>
            <p className="text-sm text-gray-500">
              {job.location} • {job.jobType} • {job.experience}
            </p>
            <p className="mt-2 text-gray-700 text-sm">{job.description}</p>
            <div className="mt-3 flex justify-between items-center">
              <span className="text-[#2B3DA8] font-bold">{job.salary}</span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default MyJob;
